import React, { useEffect, useState } from 'react';

import { UiKit } from 'components';
import { useMutation, useSegment } from 'utils/hooks';
import { useProductsCatalog } from '../../hooks';
import { isSyncInProcess, saveLastSyncTime } from '../../methods';

export default function SyncButton({
  text = 'Sync Catalog',
  processingText = 'Syncing'
}) {
  const { entity, isLoading, isError } = useProductsCatalog();
  const { track } = useSegment();
  const [isSyncing, setIsSyncing] = useState(isSyncInProcess(entity));

  useEffect(() => {
    if (isSyncing) {
      const timer = setInterval(() => {
        setIsSyncing(isSyncInProcess(entity));
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [isSyncing, entity]);

  const { mutate: onSyncCatalog } = useMutation(
    `configure.${entity}.catalog.sync`,
    'POST',
    {
      errorMessage:
        'Unable to sync catalog at the moment. Please try again later.',
      successMessage:
        'Sync started successfully. Please wait while we update your catalog.',
      onValidate: () => {
        setIsSyncing(true);
        return true;
      },
      onSuccess: () => saveLastSyncTime(entity),
      onError: () => setIsSyncing(false)
    }
  );

  const handleSync = () => {
    track(`Sync ${entity} Catalog`, { entity });
    onSyncCatalog();
  };

  return (
    <UiKit.Button
      variant={isSyncing ? 'outline' : 'secondary'}
      onClick={() => handleSync()}
      processing={isSyncing}
      processingText={processingText}
      disabled={isLoading || isError}
    >
      {text}
    </UiKit.Button>
  );
}
